"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetErrorMessage = void 0;
var React = require("react");
var theme_1 = require("../../../utils/theme");
var ApIcon_1 = require("../../ApIcon");
var styles_1 = require("./styles");
exports.ApWidgetErrorMessage = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(styles_1.Wrapper, __assign({}, props, { className: "ap-widget-error" + (className ? " " + className : '') }),
        React.createElement(ApIcon_1.ApIcon, { iconName: "widdget_error_icon", iconColor: theme_1.colors.amber, iconSize: 40 }),
        React.createElement(styles_1.MessageText, null, "The data for this insight is currently unavailable")));
};
//# sourceMappingURL=ApWidgetErrorMessage.js.map